import { set } from 'cerebral/operators'

import checkIsAdmin from '../actions/checkIsAdmin.js'
import getUsers from '../actions/getUsers.js'
import isShouldGetUsers from '../actions/isShouldGetUsers.js'
import setUsers from '../actions/setUsers.js'

export default [
  checkIsAdmin,
  {
    true: [
      isShouldGetUsers,
      {
        true: [
          getUsers,
          {
            success: [setUsers, set('state:users.currentView', 'approved')],
            error: []
          }
        ],
        false: []
      }
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/fetchUsers.js